import { render } from "./ButtonProcessOrder.vue?vue&type=template&id=aaccfdd6&scoped=true"
import script from "./ButtonProcessOrder.vue?vue&type=script&lang=js"
export * from "./ButtonProcessOrder.vue?vue&type=script&lang=js"

import "./ButtonProcessOrder.vue?vue&type=style&index=0&id=aaccfdd6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aaccfdd6"]])

export default __exports__